import { formatPhone } from "./formatPhone.js";
import { toggleFieldAttribute } from "./toggleFieldAttribute.js";

export function toggleForeignPhone(country) {
    const intlPhoneInputs = document.querySelectorAll("intl-phone-input");

    if (intlPhoneInputs.length > 0) {
        intlPhoneInputs.forEach((input) => input.setCountry(country));
    }

    const toggle = country !== "USA";

    const phoneInputs = document.querySelectorAll('[type="tel"]');

    // Remove both native and jQuery listeners before applying the desired state
    phoneInputs.forEach((input) => {
        input.removeEventListener("keyup", formatPhone);
        $(input).off("keyup", formatPhone);
    });

    if (!toggle) {
        phoneInputs.forEach((input) => {
            input.addEventListener("keyup", formatPhone);
            $(input).on("keyup", formatPhone);
        });
    }

    $("[type='tel']").each(function (index, input) {
        toggleFieldAttribute(input, "phone", !toggle);
    });
}
